import { defineStore } from 'pinia'
import type { Practitioner } from '~/repository/types/practitioner/practitioner'
import { type IApiInstance } from '../plugins/api'

export type IPractitionersState = {
  isLoaded: boolean
  isPractitionersSummaryLoaded: boolean
  practitioners: Practitioner[]
  practitioners_cms: any[]
  practitioners_specialties: any[]
  practitioners_summary: any[]
  api: IApiInstance
}

export const usePractitionersStore = defineStore('practitioners', {
  state: (): IPractitionersState => {
    return {
      isLoaded: false,
      practitioners: [],
      practitioners_cms: [],
      practitioners_specialties: [],
      practitioners_summary: [],
      isPractitionersSummaryLoaded: false,
      api: useNuxtApp().$api as IApiInstance,
    }
  },
  getters: {
    getPractitionerById: (state) => (id: string) => {
      let practitioner = state.practitioners.find((t: any) => t.id === id)
      return practitioner
    },
    getPractitionerName: (state) => (id: string) => {
      const p: any = state.practitioners.find((t: any) => t.id === id)
      return p.firstName + ' ' + p.lastName
    },
    getProfessionLabelById: (state) => (id: string) => {
      const p: any = state.practitioners_cms.find((t: any) => t.code === id)
      return p?.translations?.[0]?.name || id
    },

    getSpecialityLabelById: (state) => (id: string) => {
      const p: any = state.practitioners_specialties.find((t: any) => t.id === id)
      return p?.translations?.[0]?.name || id
    },
  },
  actions: {
    async loadPractitionerSummary() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance
      this.practitioners_summary = await api.practitioners.getPractitionerSummaries()
      if (this.practitioners_summary) {
        this.isPractitionersSummaryLoaded = true
      }
    },
    async load() {
      const api: IApiInstance = useNuxtApp().$api as IApiInstance
      this.practitioners_cms = await api.cms.getPractitioners()
      this.practitioners_specialties = await api.cms.getPractitionersSpecialities()

      if (this.practitioners_cms && this.practitioners_specialties) {
        this.isLoaded = true
      }

      api.practitioners.getV2().then((response) => {
        this.practitioners = response as Practitioner[]
      })
    },
    /**
     * An action to clear the user data from the storage, should be used upon signing out the user.
     *
     * @param {object} context - VueX store context containing commit helper for mutations.
     */
    clear() {
      this.$reset()
    },
  },
})
